import { z } from 'zod';

/////////////////////////////////////////
// COUNTRY SCHEMA
/////////////////////////////////////////

export const CountrySchema = z.object({
  id: z.string(),
  countryName: z.string(),
  callingCode: z.string(),
  iso3: z.string(),
  postalFirst: z.boolean(),
  hasStateInAddress: z.boolean(),
  postalFormat: z.string().nullable(),
  states: z.string().nullable(),
})

export type Country = z.infer<typeof CountrySchema>

export default CountrySchema;
